export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7683.87dc5cb8.jpg";